import { useEffect, useRef } from 'react';
import consultingcall_webm from '../assets/consulting/consultingcall_comp.webm';
import consultingcall_mp4 from '../assets/consulting/consultingcall_comp.mp4';
import camera from '../assets/consulting/camera.svg';
import close from '../assets/consulting/close.svg';
import fullscreen from '../assets/consulting/fullscreen.svg';
import icon_participants from '../assets/consulting/icon_participants.svg';
import microfone from '../assets/consulting/microfone.svg';
import mute from '../assets/consulting/mute.svg';
import settings1 from '../assets/consulting/settings1.svg';
import person from '../assets/consulting/Person.svg';

const Consulting3 = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(error => {
              console.log("Auto-play prevented:", error);
            });
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.1 // Trigger when 10% of the video is visible
      }
    );

    observer.observe(video);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section data-section="consulting" className="md:min-h-screen text-white px-4 relative overflow-hidden" style={{
  background: 'linear-gradient(to bottom, transparent 0%, #070709 50%, #070709 100%)',
  height: '550px'
}}>
      <div className="max-w-[960px] mx-auto pt-20">
        {/* Header Section */}
        <div className="mb-12">
          {/*<span className="font-['Geist'] font-light text-sm text-white tracking-[0.02em] pb-3 block">
            UNSERE LÖSUNG
          </span>*/}
          {/*<h2 className="font-['CalSans'] font-medium text-[48px] text-white tracking-[0.02em] text-left mb-6 leading-tight">
            Consulting that <br />turns AI into outcomes
          </h2>*/}
          <h2 className="font-['CalSans'] font-medium text-2xl sm:text-4xl lg:text-[48px] text-white tracking-[0.02em] text-left mb-6 leading-tight">
            Consulting, das KI in<br />Ergebnisse verwandelt
          </h2>
          <p className="font-['Geist'] font-normal text-sm sm:text-base text-[#ADB0B9] max-w-[585px] pb-[0px]">
            Gemeinsam analysieren wir deine Abläufe, finden die größten Hebel für Automatisierungen und entwickeln eine Roadmap, die AI in echte Ergebnisse übersetzt. Effizienter arbeiten, Kosten senken, Wachstum steigern.
          </p>
        </div>

        {/* Main Card with Blur Effect */}
        <div className="relative w-full h-auto sm:h-[550px]" style={{ aspectRatio: '16/9' }}>
          {/* Blur Backdrop */}
          <div className="absolute inset-0 -m-2 sm:-m-4 bg-white/12 backdrop-blur-[30px] rounded-2xl z-0" style={{
            transform: 'translateZ(0)',
            filter: 'blur(30px)',
            WebkitBackdropFilter: 'blur(30px)'
          }}></div>
          
          {/* Main Card */}
          <div id="consulting-main-card" className="bg-[transparent] rounded-2xl border border-[rgba(120,124,135,0.25)] border-[0.5px] w-full h-full p-2">
            <div className="w-full h-full relative rounded-lg overflow-hidden">
              {/* Updated to use WebM with MP4 fallback and resource optimizations */}
              <video 
                ref={videoRef}
                className="w-full h-full object-cover"
                loop
                muted
                playsInline
                preload="metadata"
                controls={false}
              >
                <source src={consultingcall_webm} type="video/webm" />
                <source src={consultingcall_mp4} type="video/mp4" />
              </video>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/30 flex flex-col pointer-events-none">
                {/* Top Left - Meeting Info */}
                <div className="absolute left-3 sm:left-5 top-3 sm:top-5 flex flex-col">
                  <span className="text-xs sm:text-lg font-medium leading-snug tracking-tight text-white/90">Consulting Meeting</span>
                  <span className="mt-0.5 flex items-center gap-x-1 text-[10px] sm:text-sm font-medium leading-snug tracking-tight text-white/60">
                    <img src={icon_participants} alt="Participants" className="w-2.5 h-2.5 sm:w-3 sm:h-3 opacity-60" />
                    <span>4 Teilnehmer</span>
                  </span>
                </div>
                
                {/* Right Side - Participant Groups */}
                <div className="absolute h-[20.782%] w-[20.833%] right-[1.157%] top-[2.25%]">
                  <div className="absolute right-[3.333%] top-[5.94%] flex h-[15.802%] w-[8.111%] sm:h-[19.802%] sm:w-[11.111%] items-center justify-center rounded-full bg-[#3d7eff] shadow-[0px_4px_6px_0px_#00000026]">
                    <img src={microfone} alt="Participant" className="h-1/2 w-1/2" />
                  </div>
                  <span className="absolute bottom-[5.94%] left-[3.333%] flex items-center gap-x-0.5 text-[10px] sm:text-xs font-medium leading-snug tracking-tight text-white/80">
                    <img src={person} alt="" className="w-1.5 h-1.5 sm:w-2 sm:h-2" />
                    <span className="hidden md:inline">Alex Held</span>
                  </span>
                </div>
                
                <div className="absolute h-[20.782%] w-[20.833%] right-[1.157%] top-[25.5%]">
                  <div className="absolute right-[3.333%] top-[5.94%] flex h-[15.802%] w-[8.111%] sm:h-[19.802%] sm:w-[11.111%] items-center justify-center rounded-full bg-[#989fa9] shadow-[0px_4px_6px_0px_#00000026]">
                    <img src={mute} alt="Participant" className="h-1/2 w-1/2" />
                  </div>
                  <span className="absolute bottom-[5.94%] left-[3.333%] flex items-center gap-x-0.5 text-[10px] sm:text-xs font-medium leading-snug tracking-tight text-white/80">
                    <img src={person} alt="" className="w-1.5 h-1.5 sm:w-2 sm:h-2" />
                    <span className="hidden md:inline">Lea Müller</span>
                  </span>
                </div>
                
                <div className="absolute h-[20.782%] w-[20.833%] right-[1.157%] top-[49%]">
                  <div className="absolute right-[3.333%] top-[5.94%] flex h-[15.802%] w-[8.111%] sm:h-[19.802%] sm:w-[11.111%] items-center justify-center rounded-full bg-[#3d7eff] shadow-[0px_4px_6px_0px_#00000026]">
                    <img src={microfone} alt="Participant" className="h-1/2 w-1/2" />
                  </div>
                  <span className="absolute bottom-[5.94%] left-[3.333%] flex items-center gap-x-0.5 text-[10px] sm:text-xs font-medium leading-snug tracking-tight text-white/80">
                    <img src={person} alt="" className="w-1.5 h-1.5 sm:w-2 sm:h-2" />
                    <span className="hidden md:inline">Julia Schmidt</span>
                  </span>
                </div>
                
                {/* Bottom Center - Action Buttons */}
                <div className="absolute inset-x-0 bottom-2 sm:bottom-5 flex justify-center gap-x-1.5 sm:gap-x-3.5">
                  <div className="flex aspect-square h-6 sm:h-11 items-center justify-center rounded-full shadow-[0px_4px_16px_0px_#00000059] bg-[#68686a]">
                    <img src={settings1} alt="" className="w-3 h-3 sm:w-5 sm:h-5" />
                  </div>
                  <div className="flex aspect-square h-6 sm:h-11 items-center justify-center rounded-full shadow-[0px_4px_16px_0px_#00000059] bg-[#68686a]">
                    <img src={mute} alt="" className="w-3 h-3 sm:w-5 sm:h-5" />
                  </div>
                  <div className="flex aspect-square h-6 sm:h-11 items-center justify-center rounded-full shadow-[0px_4px_16px_0px_#00000059] bg-[#ff4d4d]">
                    <img src={close} alt="" className="w-3 h-3 sm:w-5 sm:h-5" />
                  </div>
                  <div className="flex aspect-square h-6 sm:h-11 items-center justify-center rounded-full shadow-[0px_4px_16px_0px_#00000059] bg-[#68686a]">
                    <img src={camera} alt="" className="w-3 h-3 sm:w-5 sm:h-5" />
                  </div>
                  <div className="flex aspect-square h-6 sm:h-11 items-center justify-center rounded-full shadow-[0px_4px_16px_0px_#00000059] bg-[#68686a]">
                    <img src={fullscreen} alt="" className="w-3 h-3 sm:w-5 sm:h-5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Consulting3;